
// Helpers
import { loadProfile } from './storage.helper';

/**
 * Verifica si algunos de los permisos del token se encuentra entre los permisos de la app
 * @param {Array String} permissionApp Permisos configurados en la app
 * @param {Array String} permissionToken Permisos configurados en Auth0
 */
export const hasAccess = (permissionsApp = [], permissionsToken = []) => {

    return permissionsApp.find(p1 => permissionsToken.find(p2 => p1 === p2) !== undefined) !== undefined;
};

/**
 * Verifica si el usuario está habilitado
 */
export const isBranchEnabled = () => {

    const profile = loadProfile();    

    return profile.branchEnabled;
};